import WMTSLayer from '@arcgis/core/layers/WMTSLayer';
import { GISServiceTypes } from '../gisServicesTypes';
import { LayerLoader, ensureLoadedLayerArray } from './LayerLoader';
import { resolveAdminOpacity } from './defaultLayerLoader';
import { parseOgcServiceUrl } from './parseOgcServiceUrl';

/**
 * Standalone WMTS services configured in Andromeda.
 * Auth keys pasted on the URL are moved to `customParameters`.
 */
export const wmtsLayerLoader: LayerLoader = {
  shouldUseLoader(service) {
    return service.service_type == GISServiceTypes.wmts;
  },

  async load(service) {
    const adminOpacity = resolveAdminOpacity(service);
    const { url, customParameters } = parseOgcServiceUrl(
      service.gis_service_url,
    );

    const layer = new WMTSLayer({
      url,
      id: service.gisLayerID,
      activeLayer: {
        id: service?.attributes?.sublayers?.[0] || '',
      },
      visible: false,
      ...(customParameters ? { customParameters } : {}),
      ...(adminOpacity !== undefined ? { opacity: adminOpacity } : {}),
    });

    await layer.load();

    return ensureLoadedLayerArray(layer);
  },
};
